export const environment = {
  production: false,
  apiBaseUrl: 'https://testing-api.avs-digital.de/tls2-api',
  defaultGroupId: 3,
};
